'use client';

import { useState } from 'react';

import { AvatarProps, Size } from './Avatar.type';

import { PATH } from '@/shared/constants';

const length: Record<Size, number> = {
  sm: 48,
  md: 56,
};

interface AvatarContentProps extends AvatarProps {
  gradientId: string;
}

const AvatarContent = ({
  src,
  variant,
  size,
  gradientId,
}: AvatarContentProps) => {
  const [isImageLoadError, setIsImageLoadError] = useState(false);
  const isGradient = variant === 'gradient';
  const containerSize = length[size];
  const imageSize = isGradient ? containerSize - 8 : containerSize;

  const shouldShowDefaultImage = !src || isImageLoadError;

  const imageSrc = shouldShowDefaultImage
    ? `${PATH.MEDIA_YOZM_IMAGE}/default_avatar.png`
    : src;

  return (
    <div
      className="flex items-center justify-center"
      style={{
        position: 'relative',
        width: containerSize,
        height: containerSize,
      }}
    >
      {isGradient && (
        <svg
          width={containerSize}
          height={containerSize}
          viewBox={`0 0 ${containerSize} ${containerSize}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <>
            {/* gradient 테두리 */}
            <path
              d={`M1 ${containerSize / 2}C1 ${containerSize * 0.145} ${containerSize * 0.145} 1 ${containerSize / 2} 1C${containerSize * 0.855} 1 ${containerSize - 1} ${containerSize * 0.145} ${containerSize - 1} ${containerSize / 2}C${containerSize - 1} ${containerSize * 0.855} ${containerSize * 0.855} ${containerSize - 1} ${containerSize / 2} ${containerSize - 1}C${containerSize * 0.145} ${containerSize - 1} 1 ${containerSize * 0.855} 1 ${containerSize / 2}Z`}
              stroke={`url(#${gradientId})`}
              strokeWidth="2"
              fill="none"
            />
            {/* 흰색 배경 */}
            <path
              d={`M2 ${containerSize / 2}C2 ${containerSize * 0.167} ${containerSize * 0.167} 2 ${containerSize / 2} 2C${containerSize * 0.833} 2 ${containerSize - 2} ${containerSize * 0.167} ${containerSize - 2} ${containerSize / 2}C${containerSize - 2} ${containerSize * 0.833} ${containerSize * 0.833} ${containerSize - 2} ${containerSize / 2} ${containerSize - 2}C${containerSize * 0.167} ${containerSize - 2} 2 ${containerSize * 0.833} 2 ${containerSize / 2}Z`}
              fill="white"
            />
          </>

          <defs>
            {/* gradient 테두리 색 설정*/}
            <linearGradient
              id={gradientId}
              x1={containerSize / 2}
              y1="0"
              x2={containerSize / 2}
              y2={containerSize}
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E2DE2" />
              <stop offset="1" stopColor="#5A00DB" />
            </linearGradient>
          </defs>
        </svg>
      )}
      <div className="absolute">
        {/* 이미지 표시 */}
        <svg
          width={imageSize}
          height={imageSize}
          viewBox={`0 0 ${imageSize} ${imageSize}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <image
            href={imageSrc}
            width={imageSize}
            height={imageSize}
            preserveAspectRatio="xMidYMid slice"
            clipPath={`path('M0 ${imageSize / 2}C0 ${imageSize * 0.137} ${imageSize * 0.137} 0 ${imageSize / 2} 0C${imageSize * 0.863} 0 ${imageSize} ${imageSize * 0.137} ${imageSize} ${imageSize / 2}C${imageSize} ${imageSize * 0.863} ${imageSize * 0.863} ${imageSize} ${imageSize / 2} ${imageSize}C${imageSize * 0.137} ${imageSize} 0 ${imageSize * 0.863} 0 ${imageSize / 2}Z')`}
            // eslint-disable-next-line react/no-unknown-property
            onError={() => setIsImageLoadError(true)}
          />
        </svg>
      </div>
    </div>
  );
};

export default AvatarContent;
